<app-learning-hub-header
  [lang]="lang"
  [options]="languageOptions"
  (selectLanguage)="changeLanguage($event)"
></app-learning-hub-header>

<section class="lh-welcome">
  <div class="lh-welcome-inner">
    <h1 class="lh-welcome-title">{{ 'learningHub.home.title' | lhTranslate: lang }}</h1>
    <p class="lh-welcome-subtitle">{{ 'learningHub.home.subtitle' | lhTranslate: lang }}</p>
    <app-learning-hub-search-box class="lh-welcome-search" size="large" [lang]="lang"></app-learning-hub-search-box>
  </div>
</section>

<p class="lh-status" *ngIf="loading">{{ 'learningHub.loading' | lhTranslate: lang }}</p>
<p class="lh-status lh-status--error" *ngIf="!loading && error">{{ 'learningHub.loadError' | lhTranslate: lang }}</p>

<ng-container *ngIf="!loading && !error">
  <section class="lh-home-sections" aria-labelledby="lh-sections-title">
    <h2 id="lh-sections-title" class="lh-home-title">{{ 'learningHub.sectionsTitle' | lhTranslate: lang }}</h2>
    <ul class="lh-section-grid">
      <li *ngFor="let section of sections; trackBy: trackByKey" class="lh-section-card">
        <h3 class="lh-section-card-title">{{ 'learningHub.categories.' + section.category.key | lhTranslate: lang }}</h3>
        <p class="lh-section-card-description">
          {{ 'learningHub.categoryDescriptions.' + section.category.key | lhTranslate: lang }}
        </p>
        <a class="lh-section-card-link" [routerLink]="section.link" [queryParams]="{ lang: lang }">
          {{ 'learningHub.browseAll' | lhTranslate: lang }}
          <span class="lh-visually-hidden">: {{ 'learningHub.categories.' + section.category.key | lhTranslate: lang }}</span>
        </a>
      </li>
    </ul>
  </section>

  <section class="lh-home-staff" *ngIf="staffPicks.length" aria-labelledby="lh-staff-title">
    <h2 id="lh-staff-title" class="lh-home-title">{{ 'learningHub.staffPickTitle' | lhTranslate: lang }}</h2>
    <ul class="lh-staff-list">
      <li *ngFor="let article of staffPicks" class="lh-staff-item">
        <span class="lh-staff-label">{{ 'learningHub.trending' | lhTranslate: lang }}</span>
        <a class="lh-staff-link" [routerLink]="['/', modulePath, article.lang, article.slug]">{{ article.title }}</a>
      </li>
    </ul>
  </section>
</ng-container>
